import { ReactNode, MouseEvent } from "react";
import "./PageContent.scss";
import BackIcon from "images/arrow_left.svg?react";
import { HStack, VStack } from "components/Stack";
import classNames from "classnames";

interface PageContentProps {
  name?: string;
  className?: string;
  hideTitle?: boolean;
  title?: ReactNode;
  actions?: ReactNode;
  onBack?: () => void;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  children: ReactNode;
}

export default function PageContent(props: PageContentProps) {
  const className = classNames(props.className, "page", {
    [`page-${props.name}`]: props.name,
  });
  return (
    <main className={className} onClick={props.onClick}>
      {!props.hideTitle && (
        <div className="actions-panel">
          <VStack>
            {props.onBack && (
              <div style={{ cursor: "pointer" }} onClick={props.onBack}>
                <HStack gap={8} className="backBtn" align="center">
                  <BackIcon />
                  <div>Back</div>
                </HStack>
              </div>
            )}

            <div className="title">{props.title}</div>
          </VStack>

          <div className="actions">{props.actions}</div>
        </div>
      )}
      {props.children}
    </main>
  );
}
